import { Button } from "@wordpress/components";
import {cog} from "@wordpress/icons"
const logoUrl = image_hub_data?.imageUrl;
const version = image_hub_data?.version;

const Logo = ({ enableBrowseButton = false ,enableSettingsButton= false} = {}) => {
	const handleRedirect = () => {
		const adminUrl = image_hub_data?.adminUrl || "/wp-admin/";
		window.location.assign(
			`${adminUrl}upload.php?page=image-hub-media-tab`,
		);
	};
	const handleRedirectSettings = () => {
		const adminUrl = image_hub_data?.adminUrl || "/wp-admin/";
		window.location.assign(
			`${adminUrl}options-general.php?page=image-hub-settings-page`,
		);
	};

	return (
		<div
			style={{
				display: "flex",
				justifyContent: "space-between",
				paddingRight: "20px",
			}}
		>
			<div className="image-hub-logo-container">
				<div className="image-hub-logo">
					<img src={logoUrl} alt="Plugin Logo" />
				</div>
				<div className="image-hub-logo-text">
					<h1>{"Image Hub"}</h1>
				</div>
			</div>

			{!!enableBrowseButton && (
				<Button variant="primary" onClick={handleRedirect}>
					Browse Images
				</Button>
			)}
			{!!enableSettingsButton && (
				<Button icon={cog} style={{background:"white"}} variant="secondary" onClick={handleRedirectSettings}>
					Settings
				</Button>
			)}
		</div>
	);
};

export default Logo;
